var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoblet({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.414 4.443h-2.567c.01-.284.015-.57.015-.857A.586.586 0 0018.276 3H5.724a.586.586 0 00-.586.586c0 .287.005.573.014.857H2.586A.586.586 0 002 5.03c0 2.626.686 5.103 1.932 6.975 1.232 1.851 2.872 2.913 4.644 3.016.402.437.827.794 1.269 1.066v2.604h-.983a2.157 2.157 0 00-2.155 2.155v.983h-.042a.586.586 0 000 1.172h10.67a.586.586 0 100-1.172h-.042v-.983a2.157 2.157 0 00-2.155-2.155h-.983v-2.604a6.015 6.015 0 001.269-1.066c1.772-.103 3.412-1.165 4.644-3.016C21.314 10.132 22 7.654 22 5.03a.586.586 0 00-.586-.586zM4.908 11.355C3.88 9.811 3.276 7.791 3.184 5.615h2.034c.211 2.675.839 5.146 1.82 7.109.156.312.32.607.49.885-.975-.368-1.877-1.137-2.62-2.254zm11.213 9.49v.983H7.88v-.983c0-.542.44-.983.983-.983h6.276c.542 0 .983.441.983.983zm-3.138-2.155h-1.966v-2.095a3.846 3.846 0 001.966 0v2.095zm.363-3.49a2.835 2.835 0 01-1.346.351 2.836 2.836 0 01-1.346-.35c-.46-.243-.904-.61-1.325-1.092a.588.588 0 00-.074-.087A9.24 9.24 0 018.086 12.2c-1.077-2.154-1.699-4.986-1.77-8.028h11.367c-.07 3.042-.693 5.874-1.77 8.027a9.246 9.246 0 01-1.168 1.823.579.579 0 00-.075.087c-.42.482-.865.849-1.324 1.092zm5.746-3.845c-.743 1.117-1.645 1.886-2.62 2.254.17-.278.334-.573.49-.885.981-1.963 1.609-4.434 1.82-7.109h2.034c-.092 2.176-.696 4.196-1.724 5.74z"
  })));
}

export default SvgGoblet;